var audio_default = {
  "fontElementMap": "SJ7PC",
  "container": "mHOPv",
  "coverImageContainer": "YxFUY",
  "customPlayer": "_19tJt",
  "slim": "svn65",
  "playPauseButton": "MnOls",
  "coverImage": "xzEg-",
  "trackDetailsContainer": "Tb5gX",
  "controlsContainer": "_691nX",
  "controlsGroup": "Yv1UF",
  "sliderContainer": "-ed2V",
  "audioDuration": "_6fKXv",
  "isLoading": "bxlci",
  "audioDetails": "BvtUw",
  "authorName": "_7g5HZ",
  "title": "gEj9R",
  "dropdownMenuWrapper": "yOqxf",
  "dropdownSelectedButton": "LaZqw",
  "dropdownContent": "F92vQ",
  "dropdownContentWithIcon": "ZZm5m",
  "audioLoader": "kkZz1"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
